import { inject, Injectable } from '@angular/core';
import { ApiService } from 'src/app/abstract-classes/api.service/api.service';
import { Form } from 'src/app/interfaces/form';
import { FormsProviderService } from 'src/app/providers/forms/forms.provider.service';

@Injectable({
  providedIn: 'root'
})
export class FormsService extends ApiService<Form, FormsProviderService> {
  private formsProviderService = inject(FormsProviderService);
  protected override get provider(): FormsProviderService {
    return this.formsProviderService;
  }
}
